import { Trans } from 'react-i18next';
import { VStack } from '~/components/layout/Stack';
import DisclosureItem from '~/components/menu/DisclosureItem';
import Text, { SubtitleProps, TitleProps } from '~/components/typographies/Text';
import { useAnalytics } from '~/hooks/useAnalytics';
import { AnalyticsEvents } from '~/services/analytics';
import styles from './FAQ.module.scss';

interface Item {
  question: string;
  answer: string;
}

interface Props {
  title: string;
  titleProps?: TitleProps | SubtitleProps;
  items: Item[];
  gap?: 0.5 | 3;
}

const FAQ: React.FC<Props> = ({ title, items, gap = 3, titleProps = { variant: 'subtitle1', weight: undefined } }) => {
  const { track } = useAnalytics();
  return (
    <VStack gap={gap}>
      <Text {...titleProps}>{title}</Text>
      <VStack className={styles.faqList}>
        {items.map((item, index) => (
          <DisclosureItem
            key={index}
            title={item.question}
            titleProps={{
              variant: 'body1',
              weight: 'regular',
              className: styles.faqQuestion,
            }}
            onExpandedChange={(isExpanded) => {
              if (!isExpanded) return;
              track(AnalyticsEvents.FAQ_OPENED, {
                faqTitle: item.question,
              });
            }}
          >
            <Text className={styles.faqAnswer} variant="body2" weight="regular">
              <Trans
                components={{
                  sectionTitle: <p className={styles.sectionTitle} />,
                  a: <a />,
                  ol: <ol />,
                  s: <s />,
                  strong: <strong />,
                }}
              >
                {item.answer}
              </Trans>
            </Text>
          </DisclosureItem>
        ))}
      </VStack>
    </VStack>
  );
};

export default FAQ;
